import 'vite/modulepreload-polyfill';
import { registerLazy } from '@/lib/component-registry';

// Os componentes de UI estão em frontend/components/index.js
import '@/components';

// ── Cart — lazy ──────────────────────────────────────────────────────────────
// Cada módulo define seu próprio custom element internamente. O loader
// retorna null como default; o registry importa pelo efeito colateral.
registerLazy('cart-drawer-component',       () => import('@/cart/cart-drawer').then(() => ({ default: null })));
registerLazy('cart-icon',                   () => import('@/cart/cart-icon').then(() => ({ default: null })));
registerLazy('cart-note',                   () => import('@/cart/cart-note').then(() => ({ default: null })));
registerLazy('cart-discount-component',     () => import('@/cart/cart-discount').then(() => ({ default: null })));
registerLazy('cart-items-component',        () => import('@/cart/component-cart-items').then(() => ({ default: null })));
registerLazy('quantity-selector-component', () => import('@/cart/quantity-selector').then(() => ({ default: null })));

// ── Product — lazy ───────────────────────────────────────────────────────────
registerLazy('variant-picker',             () => import('@/product/variant-picker').then(() => ({ default: null })));
// variant-binding não define custom element; co-carrega com product-form-component
// pois só tem efeito em páginas com formulário de produto (ver Task 4).
registerLazy('product-form-component',     () =>
  Promise.all([
    import('@/product/product-form'),
    import('@/product/variant-binding'),
  ]).then(() => ({ default: null })),
);
